import { selectElement } from './dom-selection';
export async function retargetConnection(connection, type, cancellationSignal) { }
export function dragToCreateConnection(container, cancellationSignal, createElement) {
    return new Promise((resolve) => { });
}
export async function clickToCreateConnection(container, cancellationSignal, createElement) {
    const connection = createElement();
    // F
    connection.style.zIndex = '-1';
    container.appendChild(connection);
    function onPointerMove(event) {
        let pointerPosition = { x: event.pageX, y: event.pageY };
        if (container.folkSpace) {
            pointerPosition = container.folkSpace?.mapPointFromParent(pointerPosition);
        }
        connection.target = pointerPosition;
    }
    container.addEventListener('pointermove', onPointerMove, { capture: true, signal: cancellationSignal });
    const source = await selectElement(cancellationSignal, container);
    if (!source)
        return;
    connection.source = source;
    const target = await selectElement(cancellationSignal, container);
    console.log(target);
    connection.style.zIndex = '';
    container.removeEventListener('pointermove', onPointerMove, { capture: true });
    if (!target)
        return;
    connection.target = target;
    return connection;
}
export function clickToCreateArrow(container, cancellationSignal) {
    return clickToCreateConnection(container, cancellationSignal, () => document.createElement('folk-arrow'));
}
export async function clickToCreateEventPropagator(container, cancellationSignal) {
    const ep = await clickToCreateConnection(container, cancellationSignal, () => document.createElement('folk-event-propagator'));
    if (ep) {
        setTimeout(() => ep.focus(), 0);
    }
    return ep;
}
//# sourceMappingURL=connection.js.map